import type { FaireProductEntity } from "../../entity_types/product";

export const p_bedq9qn58g: FaireProductEntity = {
  token: "p_bedq9qn58g",
  type: "product",
  name: "Cinnamon Donuts 8-Pack (VE, GF, K, No Sugar, Soy-Free)",
  brandToken: "b_d3ssphc04o",
  brandName: "Planet Bake",
  imageUrl:
    "https://cdn.faire.com/fastly/98c56630fd3d6f2892faf08b0d8247ec0665ef8b7aac998af094a78fa83f6427.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d79111d1b725548768b2fd0bd8f9def417816c93c3693ac76f4d03e79cfcf962.png",
    "https://cdn.faire.com/fastly/a2c3f83e539f694a7ca60243711f67f9b384102bc2a83f965e507ec4a9f2428d.png",
    "https://cdn.faire.com/fastly/ed48492fbd4bdeefea3d55698bf1da9d17212aed5b497adf3ba56ced27a887f8.png",
    "https://cdn.faire.com/fastly/aa487c8125b1dbd0064055a87a1128a70b2b68dadedbf4e469d473cfd388e0af.png",
    "https://cdn.faire.com/fastly/5b7622bb0188246fdc60319242595198be20a9255142c6d015f75b367b974c82.png",
    "https://cdn.faire.com/fastly/42294619243b41d9ce0508031eb9c30576d81267074a8f9792a8c6e95114cd9a.png",
    "https://cdn.faire.com/fastly/6c646002249150f8f800328edbfe5bf78d8e180d9f50c2c21a0c50d45baeb823.png",
  ],
  priceDollars: 32.7,
  description:
    "\n\n\nBENEFITS?\n\n\n✓ VEGAN ✓ GLUTEN FREE ✓ NO ADDED SUGAR ✓ 5g NET CARBS ✓ NON GMO INGREDIENTS ✓ FIBER ✓ SOY FREE ✓ KOSHER ✓ CLEAN INGREDIENTS ✓ WOMEN-OWNED\n\nExperience a symphony of flavors with our Cinnamon Roll Donuts, meticulously crafted to tantalize your taste buds. Made with the finest Vietnamese cinnamon, each bite is a journey through layers of warmth and spice.\n\nIndulge in the perfect balance of sweetness and sophistication, making it an ideal breakfast companion or an afternoon indulgence. Energize your day without the sugar crash, as these donuts offer a guilt-free delight that satisfies your cravings.\n\nSavor the moist, cinnamon-infused texture of our Planet Bake Vietnamese Cinnamon Donuts, complemented by a tantalizing vegan white chocolate crisp glaze.",
  tags: [],
  msrpDollars: 65.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:30.758Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
